import { Prisma } from "@prisma/client";
import { BuyableItemHandler, BuyableItemOrganiser } from "../buyable-item.types";

type PartialExhibitorProfilesPack3CreditsBuyableItem = {
  exhibitorProfilesPack3CreditsOrganiser?: { id: string } | null;
};

type ExhibitorProfilesPack3CreditsBuyableItem = {
  exhibitorProfilesPack3CreditsOrganiser: { id: string };
};

type ExhibitorProfilesPack3CreditsWithOrganiser = {
  exhibitorProfilesPack3CreditsOrganiser: BuyableItemOrganiser;
};

const GROUP_KEY_PREFIX = "exhibitorProfilesPack3Credits";

export const ExhibitorProfilesPack3CreditsBuyableItemHandler = {
  displayName: "Profils exposants pack 3",
  isCumulative: true,
  accounting: {
    generalAccountCode: "706506",
    invoiceLabel: "Profils exposants pack 3",
  },

  getOrganiser(item: ExhibitorProfilesPack3CreditsWithOrganiser): BuyableItemOrganiser {
    return item.exhibitorProfilesPack3CreditsOrganiser;
  },

  isValid(item: PartialExhibitorProfilesPack3CreditsBuyableItem): boolean {
    return !!item.exhibitorProfilesPack3CreditsOrganiser?.id;
  },

  findEquivalent(
    item: PartialExhibitorProfilesPack3CreditsBuyableItem,
  ): Prisma.BuyableItemWhereInput {
    return {
      exhibitorProfilesPack3CreditsOrganiser: {
        id: item.exhibitorProfilesPack3CreditsOrganiser?.id,
      },
    };
  },

  create({
    exhibitorProfilesPack3CreditsOrganiser,
  }: ExhibitorProfilesPack3CreditsBuyableItem): Omit<Prisma.BuyableItemCreateInput, "buyableType"> {
    return {
      exhibitorProfilesPack3CreditsOrganiser: {
        connect: {
          id: exhibitorProfilesPack3CreditsOrganiser.id,
        },
      },
    };
  },

  parseGroupKeyAsWhere(groupKey: string): Prisma.BuyableItemWhereInput {
    if (!ExhibitorProfilesPack3CreditsBuyableItemHandler.isGroupKey(groupKey)) {
      throw new Error(`Invalid group key for exhibitor profiles pack 3 credits: ${groupKey}`);
    }

    const [, organiserId] = groupKey.split("|");
    return {
      exhibitorProfilesPack3CreditsOrganiser: {
        id: organiserId,
      },
    };
  },

  isGroupKey(groupKey: string): boolean {
    return groupKey.startsWith(`${GROUP_KEY_PREFIX}|`);
  },

  getGroupKey(item: PartialExhibitorProfilesPack3CreditsBuyableItem): string {
    const organiserId = item.exhibitorProfilesPack3CreditsOrganiser?.id;
    if (!organiserId) {
      throw new Error("Cannot get group key for invalid exhibitorProfilesPack3Credits item");
    }
    return `${GROUP_KEY_PREFIX}|${organiserId}`;
  },

  getPricingQuery(): Prisma.PricingFindFirstArgs {
    return {
      where: {
        backofficePrestation: {
          type: "exhibitorProfilesPack3Credits",
        },
      },
    };
  },
} as const satisfies BuyableItemHandler;
